export default function money(value, currency, fractionDigits = 2, language = "sv") {
	return new Intl.NumberFormat(language, {
		style: currency ? "currency" : undefined,
		currency: currency ? currency : undefined,
		currencyDisplay: "code",
		maximumFractionDigits: fractionDigits,
		minimumFractionDigits: fractionDigits,
	}).format(Number(value || 0));
}
